import React from 'react'
import Link from 'next/link'
import styled from 'styled-components'
import Wrapper from 'common/wrapper'
import { useCourse } from 'querys/course'
import { SecondaryButton } from 'common/button'
import { Typography } from 'common/typography'

const CertificateCardStyled = styled.div`
  padding: 24px;
  border-radius: 8px;
  margin-block-start: 24px;
  border: 1px solid var(--baseSecondary);
  .certificate-description {
    margin: 8px 0 24px;
  }
  @media (min-width: 768px) {
    margin-block-start: 40px;
    .certificate-info {
      display: flex;
      align-items: center;
    }
    .certificate-invitation {
      flex-grow: 1;
      margin-right: 16px;
    }
    .certificate-description {
      margin: 0;
    }
  }
`

function CertificateCard() {
  const { data: { certificate } } = useCourse()

  return (
    <section id="certificate">
      <Wrapper maxWidth="1200">
        <CertificateCardStyled>
          <div className="certificate-info">
            <div className="certificate-invitation">
              <Typography as="h3" small="headline6" large="headline5">
                Tu certificado
              </Typography>
              <p className="certificate-description">Añade tu certificado a Linkedin y compartelo en redes sociales.</p>
            </div>
            {certificate?.uuid ? (
              <Link href={`/certificados/${certificate.uuid}`} passHref>
                <SecondaryButton fullWidth fitContent>
                  Ver certificados
                </SecondaryButton>
              </Link>
            ) : (
              <SecondaryButton fullWidth fitContent disabled>
                Ver certificados
              </SecondaryButton>
            )}
          </div>
        </CertificateCardStyled>
      </Wrapper>
    </section>
  )
}

export default CertificateCard
